import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import {
  projectPurchase,
  SHARED_NAMESPACE,
} from '../../actions';

import Membership from '../../lib/membership';
import Purchase from '../../lib/purchase';

import {
  getCurrentPurchase,
  getCurrentUserMembership
} from '../../selectors/purchase-selector';

function withDashboardProjectionFetcher(Component) {
  class EnhancedComponent extends React.Component {
    static propTypes = {
      purchase: PropTypes.object,
      currentUserMembership: PropTypes.object,
      currentMembershipId: PropTypes.string,
      projectPurchase: PropTypes.func.isRequired
    };

    componentWillReceiveProps(nextProps) {
      if (!nextProps.currentMembershipId) return;

      if (this.props.currentMembershipId !== nextProps.currentMembershipId) {
        this.fetchDashboardProjection(nextProps);
      }
    }

    fetchDashboardProjection = (props = this.props) => {
      const {
        purchase,
        projectPurchase,
        currentMembershipId,
        currentUserMembership
      } = props;
      const { minContribution, splitType } = purchase.group;
      const {
        productOrGroupMinSlots: minSlots,
        productOrGroupMaxSlots: maxSlots
      } = purchase;
      const status = get(currentUserMembership, 'status', null);
      const claimedSlots = Membership.isCommitted(status) ? currentUserMembership.claimedSlots : 1;
      const allowedShareAmount = get(currentUserMembership, 'allowedShareAmount', minContribution);
      const projectionParams = {
        id: purchase.id,
        group: { splitType, minSlots, maxSlots, minContribution },
        memberships: [
          {
            id: currentMembershipId,
            claimedSlots,
            allowedShareAmount,
          },
        ],
      };

      if (Purchase.isGroupFull(purchase)) {
        projectionParams.memberships = [];
      }

      return projectPurchase(projectionParams, SHARED_NAMESPACE);
    }

    render() {
      return (
        <Component
          {...this.props}
          fetchDashboardProjection={this.fetchDashboardProjection}
        />
      );
    }
  }

  const mapStateToProps = (state) => {
    const purchase = getCurrentPurchase(state);
    if (!purchase) return {};
    const { memberships } = state;
    const currentUserMembership = getCurrentUserMembership(state);
    const currentMembershipId = memberships.current;

    // NOTE: Beware that currentMembershipId !== currentUserMembership.id because if there's no
    // logged in user, currentUserMembership will be null but currentMembershipId will have a random
    // value used for projections.
    return {
      purchase,
      currentUserMembership,
      currentMembershipId
    };
  };

  const mapDispatchToProps = dispatch => bindActionCreators({ projectPurchase }, dispatch);

  return connect(mapStateToProps, mapDispatchToProps)(EnhancedComponent)
}

export default withDashboardProjectionFetcher;



// WEBPACK FOOTER //
// ./src/components/hoc/with-dashboard-projection-fetcher.js